import {PENDING, FULFILLED} from '../actions/constants';
import update from 'immutability-helper';
import * as ClientActions from "../actions/ClientActions";
import * as EntryActions from "../actions/EntryActions";
import * as TaskActions from "../actions/TaskActions";

export default (state = {
    items: {},
    fetching: false,
    fetched: false,
    active: null,
    createFetching: false,
}, action) => {
    switch (action.type){
        case ClientActions.FETCH_CLIENTS + PENDING:
            return update(state, {
                fetching: {$set: true}
            });
        case ClientActions.FETCH_CLIENTS + FULFILLED:
            return update(state, {
                items: {$merge: action.payload},
                fetching: {$set: false},
                fetched: {$set: true}
            });

        case ClientActions.SAVE_CLIENT + PENDING:
            return update(state, {
                createFetching: {$set: true},
            });

        case ClientActions.SAVE_CLIENT + FULFILLED:
            return update(state, {
                createFetching: {$set: false},
                items: {$merge: action.payload},
            });

        case TaskActions.SAVE_TASK + FULFILLED: {
            // Update budget counter locally
            let object = action.payload.id ? action.payload : Object.values(action.payload)[0];
            let count = state.items[object.client.id].budgetMinutesTotal || 0;
            count += object.budgetMinutes - action.meta.previousBudgetMinutes;
            return update(state, {
                items: {
                    [object.client.id]: {
                        budgetMinutesTotal: {$set: count}
                    }
                }
            });
        }

        case EntryActions.SAVE_ENTRY + FULFILLED:
            // Update counter locally
            let object = action.payload.id ? action.payload : Object.values(action.payload)[0];
            let count = state.items[object.client.id].minutesTotal || 0;
            count += object.minutes - action.meta.previousMinutes;
            return update(state, {
                items: {
                    [object.client.id]: {
                        minutesTotal: {$set: count}
                    }
                }
            });
        case EntryActions.REMOVE_ENTRY + FULFILLED: {
            // Update counter locally
            return update(state, {
                items: {
                    [action.meta.entry.client.id]: {
                        minutesTotal: {$apply: count => count - action.meta.previousMinutes}
                    }
                }
            });
        }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/ClientsReducer.js